import Vue from 'vue'
import App from './App.vue'
import router from "./utils/router";
import store from './utils/store'
import './utils/request'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import pageTop from './components/pageTop'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(pageTop)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
